// extracted by mini-css-extract-plugin
export var active = "_sy-1";
export var circle = "_sy-0";
export var completed = "_sy-2";
export var connector = "_sy-4";
export var connectorCompleted = "_sy-7";
export var connectorSpacer = "_sy-5";
export var iconStrokeOverride = "_sy-8";
export var labelContainer = "_sy-6";
export var pending = "_sy-3";